import cloneDeep from "lodash/cloneDeep";
import { $Values } from "utility-types";
import * as api from "../../api/reportApi";

import type { FetchTransactionsReportListPayload } from "../../api/reportApi";
import type { EventType } from "../../types/eventType";

const ReportListModel = {
  state: {
    reportList: [] as Array<any>,
    reportListPerPage: 20,
    numberOfReports: 0,
    hasReportListReachedEnd: false,
    isReportListLoading: false,
  },
  reducers: {
    /**
     * adds report
     */
    addReport(state: Record<string, any>, payload: EventType): any {
      let reportList = cloneDeep(state.reportList);
      reportList.push(payload);
      return { ...state, reportList: reportList };
    },

    setReportListRequest(state: Record<string, any>): any {
      return { ...state, isReportListLoading: true };
    },

    /**
     * reset reportslist
     * BET-2527
     */
    resetReportsList(state: Record<string, any>): any {
      return { ...state, reportList: [], numberOfReports: 0 };
    },

    setReportListSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        isReportListLoading: false,
        reportList: payload.reportList,
        hasReportListReachedEnd: payload.length === 0,
        numberOfReports: payload.numberOfReports,
        totalPages: payload.totalPages,
      };
    },

    /**
     * payload: { reportList }
     */
    appendReportListSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        reportList: [...state.reportList, ...payload.reportList],
        isReportListLoading: false,
        hasReportListReachedEnd: payload.reportList.length === 0,
        numberOfReports: payload.numberOfReports,
      };
    },
  },
  effects: {
    async appendLoadSettledBetsList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ) {
      this.setReportListRequest();
      api
        .fetchSettledReportList(payload)
        .then(resp => {
          const betReportList: $Values<typeof ReportType>[] =
            resp && resp["settledBetsReports"];
          const numberOfReports = resp && resp.total;

          if (resp !== undefined && betReportList !== undefined) {
            this.appendReportListSuccess({
              reportList:
                betReportList.length > 0 ? betReportList[0].summarizedBets : [],
              numberOfReports: numberOfReports,
            });
          }
        })
        .catch(error => {
          throw error;
        });
    },

    async loadSettledReportList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ) {
      this.resetReportsList();

      this.setReportListRequest();
      api.fetchSettledReportList(payload).then(resp => {
        const betReportList: $Values<typeof ReportType>[] =
          (resp &&
            resp["settledBetsReports"] &&
            resp["settledBetsReports"][0] &&
            resp["settledBetsReports"][0].summarizedBets) ||
          [];
        const statementBets = resp?.statementBets;
        const numberOfReports = resp && resp.total;
        this.setReportListSuccess({
          reportList: statementBets,
          numberOfReports: numberOfReports,
        });
      });
    },
    async loadTransactions(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ) {
      this.resetReportsList();
      this.setReportListRequest();
      const params: FetchTransactionsReportListPayload = {
        after: payload.after,
        before: payload.before,
        transactionType: payload.transactionType,
        participant: payload.participant,
        page: payload.page,
        size: payload.size,
      };

      api.fetchTransactionsReportList(params).then(resp => {
        const betReportList = resp && resp.content;
        const numberOfReports = resp && resp.totalElements;
        const totalPages = resp && resp.totalPages;
        this.resetReportsList();
        this.setReportListSuccess({
          reportList: betReportList,
          numberOfReports: numberOfReports,
          totalPages: totalPages,
        });
      });
    },
  },
};
export default ReportListModel;
